module.exports = __webpack_public_path__ + "static/img/show.cb3f40cd.png";